// Pure helpers for the student self-signup account kinds
// (student-self-signup-prd.md §3, contract §6). No imports beyond types, so any
// Learn page can branch on them without pulling in the API client.

import type { AuthPrincipal } from './types';

/** A student who signed up with their own email (contract §6: email settings). */
export function isIndependentStudent(principal: AuthPrincipal | null | undefined): boolean {
  return principal?.kind === 'kid' && principal.account_mode === 'independent';
}

/**
 * A kid in a one-student Family with no parent (Q4/Q5): Hangar pairing and
 * Challenge entry need a parent, so Learn hides them and shows the reason.
 */
export function isStudentFamily(principal: AuthPrincipal | null | undefined): boolean {
  return principal?.kind === 'kid' && principal.family_kind === 'student';
}
